<template>

</template>

<script>
import BaseSlide from './BaseSlide';
import TeamStatusControl from "../controls/TeamStatusControl";

export default {
	name: 'AnswerSlide',
	mixins: [BaseSlide],
  components: {
	  TeamStatusControl
  },
};
</script>

<style></style>
